import React from "react"
import { truncateText } from "../../utils/functions"

interface DescriptionProps {
  description: string | React.ReactNode | undefined
  className?: string
  truncate?: boolean
  truncateLength?: number
}

export const CommonDescription = ({
  description,
  className,
  truncate = false,
  truncateLength = 100,
}: DescriptionProps) => {
  if (!description) return null

  const descriptionContent =
    typeof description === "string" && truncate
      ? truncateText(description, truncateLength)
      : description

  if (typeof descriptionContent === "object") {
    return <div className={className}>{descriptionContent}</div>
  } else {
    return (
      <div
        className={className}
        dangerouslySetInnerHTML={{ __html: descriptionContent as string }}
      />
    )
  }
}

export const CleanDescription = React.memo(
  ({
    description,
    className,
    truncate = false,
    truncateLength = 100,
  }: DescriptionProps) => {
    if (!description) return null

    const descriptionContent =
      typeof description === "string" && truncate
        ? truncateText(description, truncateLength)
        : description

    if (typeof descriptionContent === "object") {
      return <div className={className}>{descriptionContent}</div>
    } else {
      return (
        <div
          className={className}
          dangerouslySetInnerHTML={{
            __html: descriptionContent as string,
          }}
        ></div>
      )
    }
  },
)
CleanDescription.displayName = "CleanDescription"
